export { default as Call } from './Call';


// WEBPACK FOOTER //
// ./src/screens/Call/index.js